export const comments_5618663 = {"data":{"data":[],"links":{}}}